import { DashboardLayout } from "@/components";
import { stAdminMiddleware } from "@/middleware";
import { STAdminTransactions } from "@/pages/st-admin";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

const stringList = z
	.union([z.string(), z.array(z.string())])
	.transform((v) => (typeof v === "string" ? [v] : v ?? []))
	.default([]);

const SearchSchema = z.object({
	orderEmail: z.string().optional().default(""),
	senderEmail: z.string().optional().default(""),
	states: stringList,
	/** Resource ids. */
	players: stringList,
});

export type TransactionSearch = z.infer<typeof SearchSchema>;

export const Route = createFileRoute("/st-admin/transactions/")({
	validateSearch: zodValidator(SearchSchema),
	component: () => (
		<DashboardLayout>
			<STAdminTransactions />
		</DashboardLayout>
	),
	loader: stAdminMiddleware,
});
